import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import FilledButton from 'components/application/buttons/FilledButton';
import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

export default function DestroyModal({
  fieldAttribute,
  isOpen,
  onDestroy,
  setClose,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'settings.personnel.information.DestroyModal',
  });

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const handleDeleteClick = () => {
    setClose();
    onDestroy();
  };

  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-3'
            color='blue'
            onClick={setClose}
            size='md'
          >
            {i18nTShared('cancel')}
          </TextButton>
          <FilledButton color='red' onClick={handleDeleteClick}>
            {fieldAttribute.fieldValueCount ?
              i18nTShared('deleteRecordsWithCount', {
                count: fieldAttribute.fieldValueCount,
              })
            : i18nTShared('delete')}
          </FilledButton>
        </div>
      }
      isOpen={isOpen}
      mode='flexible'
      onClose={setClose}
    >
      <div className='modalbox-body'>
        <div className='tw-mb-4 tw-text-l tw-font-semibold tw-text-grey-900'>
          {fieldAttribute.default ?
            i18nT('title', {
              interpolation: { escapeValue: false },
              name: fieldAttribute.name,
            })
          : i18nTShared('areYouSureYouWantToDelete', {
              interpolation: { escapeValue: false },
              name: fieldAttribute.name,
            })
          }
        </div>
        <div>
          {i18nT(`body.${fieldAttribute.default ? 'default' : 'nonDefault'}`)}
        </div>
      </div>
    </ModalBox>
  );
}

DestroyModal.propTypes = {
  fieldAttribute: PropTypes.exact({
    default: PropTypes.bool.isRequired,
    fieldValueCount: PropTypes.number.isRequired,
    formattedFieldType: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onDestroy: PropTypes.func.isRequired,
  setClose: PropTypes.func.isRequired,
};
